import React from 'react'
import { Grid, Button } from '@material-ui/core'
import logo from '../../../logo/logoLaridae-g.png'
import logoTq from '../../../logo/isotipo-tq-g.png'
import LoginInfo from '../../Auth/containers/LoginInfo'

function HeaderApp (props) {
  const { hideButton = false } = props
  return (
    <>
      <Grid item xs={12} sm container alignItems='center' justify='space-around'>
        { !hideButton
          ? <div>
            <Button
              style={{ padding: '0', marginTop: '4px' }}
              disableFocusRipple={false}
              href='/laridae'
            >
              <img src={logo} className='App-laridae-logo' alt='logo' />
            </Button>
            <p className='app-laridae-name'>
                Laridae 7
            </p>
          </div>
          : <div>
            <div style={{ padding: '0', marginTop: '4px' }}>
              <img src={logo} className='App-laridae-logo' alt='logo' />
            </div>
            <p className='app-laridae-name'>
                  Laridae 7
            </p>
          </div>
        }
        <Grid item xs className='pag-name'>
          <h6 className='titulo-menudrawer'>
              Terminal Quequén S.A.
          </h6>
        </Grid>
        <Grid item style={{ margin: '0 8% 0 0' }}>
          <LoginInfo color='#cfcfcf' />
        </Grid>
      </Grid>

      <header className='float-right'>
        <div className='float-right' />
        <div>
          <img src={logoTq} className='App-inst-logo' alt='logo' />
        </div>

      </header>
    </>
  )
}

export default HeaderApp
